import { Injectable } from '@angular/core';
import {ApiService} from "./api.service";
import {UserService} from "./user.service";
import {PopupService} from "./popup.service";

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(
    private apiService: ApiService,
  ) { }


  /**
   * @desc Provide feature feedback
   * @param data
   */
  feature_feedback(data: any) {
    return this.apiService.doRequest('api/feedback/feature', 'POST', data);
  }

  comment(data: any){
    return this.apiService.doRequest('api/feedback/comment', 'POST', data);
  }
}
